import SettingsService from "../../_services/api/settings/graycorp/settings.service";

export async function getSortSettingsFromCombinedSetting(settingName, validColumns) {
    try {
        const response = await SettingsService.getBySettingName(settingName);

        if (
            response &&
            response.data &&
            Array.isArray(response.data.value) &&
            response.data.value.length > 0
        ) {
            const settingValue = response.data.value[0].SettingValue;

            if (typeof settingValue === "string" && settingValue.trim().length > 0) {
                const pairs = settingValue.split(",");

                var result = [];
                var sortIndex = 0;

                for (var i = 0; i < pairs.length; i++) {
                    var pair = pairs[i].trim(); // e.g., "ReleaseDate desc"
                    var parts = pair.split(/\s+/); // split by spaces

                    if (parts.length !== 2) {
                        continue; // invalid format
                    }

                    var col = parts[0].trim();
                    var dir = parts[1].trim().toLowerCase();

                    var isValidColumn = validColumns.indexOf(col) !== -1;
                    var isValidDirection = dir === "asc" || dir === "desc";

                    if (isValidColumn && isValidDirection) {
                        result.push({
                            dataField: col,
                            sortOrder: dir,
                            sortIndex: sortIndex++,
                        });
                    }
                }

                return result;
            }
        }

        return [];
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log("Error parsing sort setting:", settingName, error);
        return [];
    }
}
